import { __decorate } from "tslib";
import { Vue, Component, Prop } from "vue-property-decorator";
let HeaderRU = class HeaderRU extends Vue {
    customer;
    company;
};
__decorate([
    Prop({})
], HeaderRU.prototype, "customer", void 0);
__decorate([
    Prop({})
], HeaderRU.prototype, "company", void 0);
HeaderRU = __decorate([
    Component({})
], HeaderRU);
export default HeaderRU;
